/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitStatus } from './PressKitStatus';
import {
    PressKitStatusFromJSON,
    PressKitStatusFromJSONTyped,
    PressKitStatusToJSON,
} from './PressKitStatus';

/**
 * 
 * @export
 * @interface PostPressKitBodyStatus
 */
export interface PostPressKitBodyStatus {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyStatus
     */
    objectId: string;
    /**
     * 
     * @type {PressKitStatus}
     * @memberof PostPressKitBodyStatus
     */
    status: PressKitStatus;
}

/**
 * Check if a given object implements the PostPressKitBodyStatus interface.
 */
export function instanceOfPostPressKitBodyStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PostPressKitBodyStatusFromJSON(json: any): PostPressKitBodyStatus {
    return PostPressKitBodyStatusFromJSONTyped(json, false);
}

export function PostPressKitBodyStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'status': PressKitStatusFromJSON(json['status']),
    };
}

export function PostPressKitBodyStatusToJSON(value?: PostPressKitBodyStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'status': PressKitStatusToJSON(value.status),
    };
}

